import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { take } from 'rxjs/operators';
import { decryptPledgeData } from 'src/app/shared/crypto-js/crypto-js';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router, 
    private authService: AuthService, 
    private cookie: CookieService,
    private route: ActivatedRoute) 
    { }



  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
   
    const encryptedUserSession = localStorage.getItem('encryptedUserSession');
    if (encryptedUserSession) {
      try {
        const decryptedStr = decryptPledgeData(encryptedUserSession);
        const decryptedData = JSON.parse(decryptedStr);
        const token  = decryptedData?.token;

        if (token) {
          return true; 
        }
      } catch {
        // Corrupt/stale local session — force re-login
        localStorage.removeItem('encryptedUserSession');
        localStorage.removeItem('login_code');
        localStorage.removeItem('got');
        localStorage.removeItem('userData');
        localStorage.removeItem('userDataTime');
      }
    }


    if (this.cookie.check('encryptedUserSession')) {
      return true;
    } else if (sessionStorage.getItem('nominee')) {
      return this.router.createUrlTree(['/account/nominee']); 
    }
    else if (sessionStorage.getItem('f15')) {
      return this.router.createUrlTree(['/f15']);
    }
    else {
      if (state.url.includes('family')) {
        sessionStorage.setItem('account_family', state.url);
        this.router.navigate(['/']);
      } 

      else if(state.url.includes('gift-accept')){
        sessionStorage.setItem('gift-accept', state.url);
        this.router.navigate(['/']);
      }

      else if(state.url.includes('portfolio')){
        sessionStorage.setItem('holdings', state.url);
        this.router.navigate(['/']);
      }

      else if(state.url.includes('f15')){
        sessionStorage.setItem('f15', state.url);
        this.router.navigate(['/']);
      }
      else if(state.url.includes('ddpi')){
        sessionStorage.setItem('ddpi', state.url);
        this.router.navigate(['/']);
      }
      else if(state.url.includes('pledge')){
        sessionStorage.setItem('pledge', state.url);
        this.router.navigate(['/']);
      }
      else if(state.url.includes('family')){
        sessionStorage.setItem('family', state.url);
        this.router.navigate(['/']);
      }
      

      else {
        setTimeout(() => {
          this.router.navigate(['/']);
        }, 600);
      }
      return false;

    }
  }
}
